import React, { useEffect } from 'react';
import { useAuth } from '../../../../../../contexts/userContext/userContext';
import BookingInfoForm from '../../../../../forms/bookingInfo/BookingInfoForm';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';

function BookingInfo() {
  const { bookingInfoForm, options } = useBooking();
  const { user } = useAuth();

  useEffect(() => {
    if (options?.countries) {
      const userCountry = options.countries.find(
        (country) => country.id === (user?.country || user?.citizenship),
      );
      const userCountryPhoneCOde = options.phoneCodes.find(
        (code) => code.label === user?.country_phone_code,
      );
      bookingInfoForm.setFieldsValue({
        booker: {
          ...user,
          country: userCountry?.name_ka,
          phone_number: user?.phone_number,
          country_phone_code: userCountryPhoneCOde?.value,
          id_number: user?.personal_number || user?.identification_number || user?.passport_number,
        },
      });
    }
  }, [user, bookingInfoForm, options]);

  return (
    <BookingInfoForm form={bookingInfoForm} options={options} />
  );
}

export default BookingInfo;
